// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__2nTlA","error":"InputSecondary_error__1QGG-","disabled":"InputSecondary_disabled__3Mm87"};